import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-arrow-right\">\n<path id=\"icon-arrow-right_路径\" d=\"M780.1,519.4c0-13-4.8-24.4-15-34.2L340,83.4c-9.1-9.3-20.9-14-34.9-14c-27.9,0-49.3,20.2-49.3,47.2\n\tc0,13.5,5.9,24.9,14.5,33.7l390.3,369.1L270.3,888.5c-8.6,8.8-14.5,20.7-14.5,33.7c0,27,21.4,47.2,49.3,47.2\n\tc13.9,0,25.7-4.7,34.9-13.5l425.1-402.3C775.3,544.3,780.1,532.4,780.1,519.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol